import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminClientTable from "../../../components/admin/client/account/AdminClientTable";

//어드민 클라이언트 페이지
const AdminClientPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*클라이언트 테이블*/}
            <AdminClientTable/>
        </AdminLayout>
    )
}

export default AdminClientPage;